export enum VisibleContentForSelectAddObject {
  SELECT_OBJECT,
  ADD_OBJECT
}
